import { Member } from './member.model';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, Injector } from '@angular/core';
import { MembersService } from 'src/app/pages/members/members.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})
export class MembersComponent extends BaseListComponent<Member>  {

    constructor(
      public memberServ:MembersService,
      public injector:Injector,
      public auth:AuthService,
      public toastr:ToastrManager,
    ){
      super(memberServ, injector, 'member', {editUrl:'/admin/members/edit', createUrl:'/admin/members/new',detailUrl:'/admin/members/detail'});
    }
  
    // unimplemented method
    protected initChildProprieties(): void {}
    
    
    // unimplemented method
    protected initChildMethods(): void {}
  
    tableProprieties(): string[] {
      const columns= [
        'Nº de Sócio',
        'Nome',
        'Email',
        'Telefone',
        'Clube',
        'Quota Subscrita',
        'Estado'
      ];

      if(!this.isAdminOrUserKhuzela()) {
        columns.splice(4,1)
      }
  
      return columns;
    }
  }
  